import React from 'react';

type Variant = 'primary' | 'outline' | 'ghost';
type Size = 'sm' | 'md' | 'lg';

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: Variant;
  size?: Size;
  fullWidth?: boolean;
}

const baseClasses =
  'inline-flex items-center justify-center rounded-full font-medium tracking-wide focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2 focus-visible:ring-offset-background disabled:cursor-not-allowed disabled:opacity-60 transition-all duration-200 ease-soft-spring active:scale-[0.97]';

const variantClasses: Record<Variant, string> = {
  primary:
    'bg-gradient-to-r from-primarySoft to-secondary text-white shadow-soft-elevated hover:brightness-[1.05]',
  outline:
    'border border-borderSoft/70 bg-surface/70 text-text hover:bg-surfaceElevated/80 hover:border-borderSoft',
  ghost: 'text-text hover:bg-surfaceMuted/80'
};

const sizeClasses: Record<Size, string> = {
  sm: 'px-3 py-1.5 text-[11px]',
  md: 'px-4 py-2.5 text-xs',
  lg: 'px-5 py-3 text-sm'
};

export const Button: React.FC<ButtonProps> = ({
  variant = 'primary',
  size = 'md',
  fullWidth,
  className,
  children,
  ...rest
}) => {
  return (
    <button
      className={[
        baseClasses,
        variantClasses[variant],
        sizeClasses[size],
        fullWidth ? 'w-full' : '',
        className
      ]
        .filter(Boolean)
        .join(' ')}
      {...rest}
    >
      {children}
    </button>
  );
};


